// extracted by mini-css-extract-plugin
module.exports = {"AssetTitle__title__1_IwK":"AssetTitle__title__1_IwK","AssetTitle__asset-title__F_0Au":"AssetTitle__asset-title__F_0Au"};